/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getRuntimeMetadata} from '../api'

 export const useQueryGetRuntimeMetadata = createReactQueryHook('getRuntimeMetadata', getRuntimeMetadata)
